function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-7{stroke-miterlimit:10;}.cls-7{fill:none;stroke-width:2px;}.cls-8{isolation:isolate;}.cls-9{mix-blend-mode:multiply;opacity:.8;}.fill-none{ fill: none}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-8"
}, /*#__PURE__*/React.createElement("g", {
  id: "_"
}, /*#__PURE__*/React.createElement("rect", {
  className: "icon-secondary",
  x: -433.15,
  y: -434.61,
  width: 1159,
  height: 771
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "fill-none",
  x: 11.25,
  y: 13.38,
  width: 220,
  height: 186,
  rx: 3,
  ry: 3
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M198.25,182.38H44.25c0-8.84-7.16-16-16-16V46.38c8.84,0,16-7.16,16-16H198.25c0,8.84,7.16,16,16,16v120c-8.84,0-16,7.16-16,16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M154.25,79.38H88.25c-1.1,0-2-.9-2-2s.9-2,2-2h66c1.1,0,2,.9,2,2s-.9,2-2,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M193.25,93.38h-51c-1.1,0-2-.9-2-2s.9-2,2-2h51c1.1,0,2,.9,2,2s-.9,2-2,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M128.25,93.38H50.25c-1.1,0-2-.9-2-2s.9-2,2-2h78c1.1,0,2,.9,2,2s-.9,2-2,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M193.25,107.38H115.64c-1.1,0-2-.9-2-2s.9-2,2-2h77.62c1.1,0,2,.9,2,2s-.9,2-2,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M101.64,107.38H50.25c-1.1,0-2-.9-2-2s.9-2,2-2h51.38c1.1,0,2,.9,2,2s-.9,2-2,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M127.71,121.38h-35.62c-1.1,0-2-.9-2-2s.9-2,2-2h35.62c1.1,0,2,.9,2,2s-.9,2-2,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M78.1,121.38h-27.85c-1.1,0-2-.9-2-2s.9-2,2-2h27.85c1.1,0,2,.9,2,2s-.9,2-2,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M116.94,135.38H50.25c-1.1,0-2-.9-2-2s.9-2,2-2H116.94c1.1,0,2,.9,2,2s-.9,2-2,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M111.94,149.38h-28.69c-1.1,0-2-.9-2-2s.9-2,2-2h28.69c1.1,0,2,.9,2,2s-.9,2-2,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M70.1,149.38h-19.85c-1.1,0-2-.9-2-2s.9-2,2-2h19.85c1.1,0,2,.9,2,2s-.9,2-2,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "M59.3,169.38c-3.67,0-7.29-.96-10.3-3.41-.86-.7-.99-1.96-.29-2.81,.7-.86,1.96-.99,2.81-.29,5.08,4.13,12.8,2.59,18.33-.23,8.61-4.39,17.08-4.3,22.67,.23,.86,.7,.99,1.96,.29,2.81-.7,.86-1.96,.99-2.81,.29-4.32-3.5-11.17-3.42-18.33,.23-3.6,1.83-8.02,3.18-12.36,3.18Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "icon-primary",
  points: "184.25 44.38 58.25 44.38 64.88 54.38 58.25 64.38 184.25 64.38 177.62 54.38 184.25 44.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "icon-primary",
  points: "134.25 157.38 134.25 227.38 157.25 214.05 157.25 157.38 134.25 157.38"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "icon-primary",
  points: "157.25 157.38 157.25 214.05 180.25 227.38 180.25 157.38 157.25 157.38"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon-primary",
  cx: 157.25,
  cy: 153.38,
  r: 36
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-secondary",
  d: "M178.61,153.38c0-.56,.34-1.54,.65-2.41,.69-1.97,1.55-4.42,.51-6.92-1.07-2.57-3.46-3.71-5.38-4.62-.28-.13-.56-.27-.83-.41-.51-.26-.98-.52-1.21-.74-.34-.34-.77-1.25-1.15-2.04-.91-1.92-2.05-4.31-4.62-5.38-2.5-1.03-4.95-.18-6.92,.51-.87,.3-1.85,.65-2.41,.65s-1.54-.35-2.41-.65c-1.97-.69-4.42-1.55-6.92-.51-2.57,1.07-3.71,3.46-4.62,5.38-.38,.8-.81,1.7-1.15,2.04-.34,.34-1.24,.77-2.04,1.15-1.92,.91-4.31,2.05-5.38,4.62-1.03,2.5-.18,4.95,.51,6.92,.3,.87,.65,1.85,.65,2.41s-.34,1.54-.65,2.41c-.69,1.97-1.55,4.42-.51,6.92,1.07,2.57,3.46,3.71,5.38,4.62,.8,.38,1.7,.81,2.04,1.15,.34,.34,.77,1.24,1.15,2.04,.91,1.92,2.05,4.31,4.62,5.38,.83,.35,1.67,.48,2.47,.48,1.61,0,3.13-.53,4.45-.99,.87-.3,1.85-.65,2.41-.65,.14,0,.3,.02,.48,.06,.55,.11,1.27,.36,1.93,.59,1.97,.69,4.42,1.55,6.92,.51,2.57-1.07,3.71-3.46,4.62-5.38,.38-.8,.81-1.7,1.15-2.04s1.25-.77,2.04-1.15c1.92-.91,4.31-2.05,5.38-4.62,1.04-2.5,.18-4.95-.51-6.92-.3-.87-.65-1.85-.65-2.41Zm-7.04,8.02c-1.28,.61-2.72,1.29-3.86,2.44-1.14,1.14-1.83,2.59-2.44,3.86-.34,.72-.91,1.92-1.12,2.1-.4,.05-1.59-.37-2.31-.62-.45-.16-.92-.31-1.41-.46-.99-.3-2.05-.55-3.17-.55-1.67,0-3.22,.54-4.58,1.02-.71,.25-1.9,.67-2.18,.67h0c-.33-.23-.9-1.43-1.25-2.15-.61-1.28-1.29-2.72-2.44-3.86-1.14-1.14-2.59-1.83-3.86-2.44-.72-.34-1.92-.91-2.1-1.12-.05-.39,.37-1.59,.62-2.31,.48-1.36,1.02-2.91,1.02-4.58s-.54-3.22-1.02-4.58c-.25-.72-.67-1.92-.66-2.19,.23-.33,1.43-.9,2.15-1.25,1.28-.61,2.72-1.29,3.86-2.44,1.14-1.14,1.83-2.59,2.44-3.86,.34-.72,.91-1.92,1.12-2.1,.02,0,.05,0,.08,0,.45,0,1.56,.39,2.23,.62,1.36,.48,2.91,1.02,4.58,1.02s3.22-.54,4.58-1.02c.72-.25,1.91-.6,2.19-.66,.33,.23,.9,1.43,1.25,2.15,.61,1.28,1.29,2.72,2.44,3.86,.95,.95,2.1,1.58,3.19,2.11,.23,.11,.45,.22,.67,.33,.72,.34,1.92,.91,2.1,1.12,.05,.39-.37,1.59-.62,2.31-.48,1.36-1.02,2.91-1.02,4.58s.54,3.22,1.02,4.58c.25,.72,.67,1.92,.66,2.19-.23,.33-1.43,.91-2.15,1.25Z"
}))));

function SvgCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 239.21 235.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.9beb56e7.svg";
export { ForwardRef as ReactComponent };